var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from "mobx";
import { FeatureFlag } from "healthex-common/features.dtos";
import { NamedRoutes } from "./NamedRoutes";
import { MobileBottomNavigationButtonType } from "./PatientResearchDashboardUIManager";
export class PatientMobileNavBarViewModel {
    constructor(container) {
        this.profilePopoverOpen = false;
        this.profilePopoverOriginRect = null;
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.dashboardUIManager = container.patientResearchDashboardUIManager;
        this.appUIManager = container.appUIManager;
        this.featureManager = container.featureManager;
    }
    get isHealthWalletEnabled() {
        return this.featureManager.isFeatureEnabled(FeatureFlag.RO_HEALTH_WALLET_ENABLED);
    }
    openPatientProfilePopover(rect) {
        if (rect === undefined || rect === null) {
            this.profilePopoverOriginRect = null;
        }
        else {
            this.profilePopoverOriginRect = {
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
            };
        }
        this.profilePopoverOpen = true;
    }
    closePatientProfilePopover() {
        this.profilePopoverOpen = false;
    }
    clearProfilePopoverOrigin() {
        this.profilePopoverOriginRect = null;
    }
    get userForAvatar() {
        return this.authManager.userForAvatar;
    }
    get isHistoryTabActive() {
        return this.dashboardUIManager.selectedBottomNavigationButton === MobileBottomNavigationButtonType.HISTORY;
    }
    get isSharingTabActive() {
        return this.dashboardUIManager.selectedBottomNavigationButton === MobileBottomNavigationButtonType.RESEARCH;
    }
    get selectedTabIndex() {
        return this.isSharingTabActive ? 1 : 0;
    }
    onTabChange(index) {
        if (index === 1) {
            this.selectSharingTab();
        }
        else {
            this.selectHistoryTab();
        }
    }
    onAvatarClick(rect) {
        this.openPatientProfilePopover(rect);
    }
    selectHistoryTab() {
        this.dashboardUIManager.goToPage(MobileBottomNavigationButtonType.HISTORY);
    }
    selectSharingTab() {
        this.dashboardUIManager.goToPage(MobileBottomNavigationButtonType.RESEARCH);
    }
    logoOnClick() {
        var _a;
        if (((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION.routeName) {
            this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_PATIENT);
        }
        else {
            this.appUIManager.navigateToHome();
        }
    }
}
__decorate([
    computed
], PatientMobileNavBarViewModel.prototype, "isHealthWalletEnabled", null);
__decorate([
    observable
], PatientMobileNavBarViewModel.prototype, "profilePopoverOpen", void 0);
__decorate([
    observable
], PatientMobileNavBarViewModel.prototype, "profilePopoverOriginRect", void 0);
__decorate([
    action
], PatientMobileNavBarViewModel.prototype, "openPatientProfilePopover", null);
__decorate([
    action
], PatientMobileNavBarViewModel.prototype, "closePatientProfilePopover", null);
__decorate([
    action
], PatientMobileNavBarViewModel.prototype, "clearProfilePopoverOrigin", null);
__decorate([
    computed
], PatientMobileNavBarViewModel.prototype, "userForAvatar", null);
__decorate([
    computed
], PatientMobileNavBarViewModel.prototype, "isHistoryTabActive", null);
__decorate([
    computed
], PatientMobileNavBarViewModel.prototype, "isSharingTabActive", null);
__decorate([
    computed
], PatientMobileNavBarViewModel.prototype, "selectedTabIndex", null);
__decorate([
    action
], PatientMobileNavBarViewModel.prototype, "onAvatarClick", null);
